import { execSync } from "node:child_process";

/** Fetch full git history if the repo was cloned with --depth=1. */
export function unshallowRepo(workspaceDir: string): void {
  try {
    execSync("git fetch --unshallow", {
      cwd: workspaceDir,
      timeout: 60_000,
      stdio: "ignore",
    });
  } catch {
    // Already unshallowed or not a shallow clone
  }
}
